/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';

import Select from '../Primitives/Select';
import { useAllCountries } from '../../context/customerAccount/queries/useAllCountries';

declare global {
    interface Array<T> {
        move(from: number, to: number): void;
    }
}

Array.prototype.move = function (from: number, to: number) {
    this.splice(to, 0, this.splice(from, 1)[0]);
};

const NONE_SELECT_VALUE = '---------';

type MagentoCountry = {
    id: string;
    full_name_locale: string;
    full_name_english: string;
    available_regions: [
        {
            code: string;
            id: string;
            name: string;
        }
    ];
};

type CountryNameSelectProps = {
    countryName: string;
    isDisabled?: boolean;
    onChange: (countryName: string) => void;
    firstOption: string;
    errorMessage: string;
    validateValue: (value: string) => void;
};

export const CountryNameSelect: React.FC<CountryNameSelectProps> = ({
    countryName,
    isDisabled,
    onChange,
    firstOption,
    errorMessage,
    validateValue,
}) => {
    const { currentLocale } = usePageLocalization();
    const { countries } = useAllCountries();

    useEffect(() => {
        addNoneItem(countries);
    }, []);

    const moveCanadaUsOnTop = (
        countries: MagentoCountry[]
    ): MagentoCountry[] => {
        ['US', 'CA'].forEach((code: string) => {
            const codeIndex = countries.findIndex((c) => c.id == code);
            countries.move(codeIndex, 0);
        });
        return countries;
    };

    const addNoneItem = (countries: MagentoCountry[]) => {
        if (!countries.some((country) => country.id == 'NONE')) {
            countries.unshift({
                id: 'NONE',
                full_name_locale: NONE_SELECT_VALUE,
                full_name_english: NONE_SELECT_VALUE,
                available_regions: [
                    {
                        code: 'NONE',
                        id: 'NONE',
                        name: NONE_SELECT_VALUE,
                    },
                ],
            });
        }
    };

    return (
        <Select
            elements={moveCanadaUsOnTop(countries).map((country) =>
                currentLocale === 'fr_CA'
                    ? country.full_name_locale
                    : country.full_name_english
            )}
            isDisabled={isDisabled}
            firstOption={firstOption}
            error={errorMessage}
            value={countryName}
            onChange={(value: string) => {
                if (value != NONE_SELECT_VALUE) {
                    onChange(value);
                }
            }}
            validateInput={() => validateValue(countryName)}
        />
    );
};
